import { CAMPAIGN_LABEL_TYPE_FIELDS, LONG } from 'utils/fieldTypes';

// Used only to alter the display value of types
export const DISPLAY_TYPES = {
  [CAMPAIGN_LABEL_TYPE_FIELDS[0]]: LONG,
};
